import { Routes } from '@angular/router';
import { PartnerPortalLayoutComponent } from '../partner-portal/partner-portal-layout/partner-portal-layout.component';
import { MentorsListComponent } from '../super-admin/mentors-list/mentors-list.component';
import { StudentListComponent } from '../super-admin/student-list/student-list.component';
import { ViewProfileComponent } from '../student-portal/view-profile/view-profile.component';
import { EditManageCollegesComponent } from '../super-admin/edit-manage-colleges/edit-manage-colleges.component';
import { AddInstituteComponent } from '../super-admin/add-institute/add-institute.component';
import { CommonQuestionComponent } from '../super-admin/common-question/common-question.component';
import { AdminManagementComponent } from '../super-admin/admin-management/admin-management.component';
import { AddSchoolComponent } from '../super-admin/add-school/add-school.component';
import { PeerManagementComponent } from '../super-admin/peer-management/peer-management.component';
import { PeerListComponent } from '../super-admin/peer-list/peer-list.component';
import { PeerTimingsComponent } from '../peer-portal/peer-timings/peer-timings.component';
import { ScheduledPeerCallsComponent } from '../super-admin/sceduled-peer-calls/scheduled-peer-calls/scheduled-peer-calls.component';
import { ScheduledMentorCallsComponent } from '../super-admin/scheduled-mentor-calls/scheduled-mentor-calls/scheduled-mentor-calls.component';
import { PeerMeetingsComponent } from '../peer-portal/peer-meetings/peer-meetings.component';
import { ReportingComponent } from '../super-admin/reporting/reporting.component';
import { MindlerTestComponent } from '../super-admin/mindler-test/mindler-test.component';
import { AddScholarshipsComponent } from '../super-admin/add-scholarships/add-scholarships.component';
import { StudentMentorRequestsComponent } from '../super-admin/student-mentor-requests/student-mentor-requests.component';
import { PermissionGuard } from '../guards/permission.guard';
import { UserRole } from '../models/enums/UserRole';
import { IntegrationsComponent } from '../super-admin/integrations/integrations.component';
import { PackagesComponent } from '../super-admin/payments/packages/packages.component';
import { PromocodesComponent } from '../super-admin/payments/promocodes/promocodes.component';
import { PaymentReportsComponent } from '../super-admin/payments/payment-reports/payment-reports.component';
import { PackagePurchasesComponent } from '../super-admin/package-purchases/package-purchases.component';
import { ContactUsRequestsComponent } from '../super-admin/contact-us-requests/contact-us-requests.component';
import { LoginToAirtelComponent } from '../super-admin/login-to-airtel/login-to-airtel.component';
import { DynamicFormsComponent } from '../super-admin/dynamic-forms/dynamic-forms.component';
import { PeerSignupComponent } from '../peer-signup/peer-signup.component';
import { AccountCentreComponent } from '../student-portal/account-centre/account-centre.component';
import { ChatComponent } from '../student-portal/chat/chat.component';

export const adminRoutes: Routes = [
  {
    path: 'admin', component: PartnerPortalLayoutComponent,
    data: { portal: 'partner' },
    children: [
      {
        path: '', redirectTo: 'colleges', pathMatch: 'full'
      },
      {
        path: 'mentors', component: MentorsListComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'students', component: StudentListComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.SchoolAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'view-profile/:id',
        component: ViewProfileComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.SchoolAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'colleges', component: EditManageCollegesComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'add-college', component: AddInstituteComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'add-college/:id', component: AddInstituteComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'common-question', component: CommonQuestionComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'admin-management', component: AdminManagementComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'add-school', component: AddSchoolComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'peer-management', component: PeerManagementComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'peer-management/:id', component: PeerManagementComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'peer-list', component: PeerListComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'peer-signup', component: PeerSignupComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'timings/:id', component: PeerTimingsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'scheduled-peer-calls', component: ScheduledPeerCallsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'scheduled-mentor-calls', component: ScheduledMentorCallsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'peer-meetings', component: PeerMeetingsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'reporting', component: ReportingComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'mindler-tests', component: MindlerTestComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'add-scholarships', component: AddScholarshipsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'student-mentor-requests', component: StudentMentorRequestsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'contact-us-requests', component: ContactUsRequestsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'partner-logins', component: LoginToAirtelComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'integrations', component: IntegrationsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'packages', component: PackagesComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'promocodes', component: PromocodesComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'payment-reports', component: PaymentReportsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin,UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'package-purchases', component: PackagePurchasesComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'dynamic-forms', component: DynamicFormsComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'dynamic-forms/create', loadComponent: () => import('../super-admin/dynamic-forms/form-builder/form-builder.component').then(m => m.FormBuilderComponent),
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'dynamic-forms/edit/:id', loadComponent: () => import('../super-admin/dynamic-forms/form-builder/form-builder.component').then(m => m.FormBuilderComponent),
        data: {
          expectedRoles: [UserRole.SuperAdmin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'account-centre', component: AccountCentreComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'chat', component: ChatComponent,
        data: {
          expectedRoles: [UserRole.SuperAdmin, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      }
    ]
  }
];

